export default __webpack_public_path__ + "static/kb_2_4-4f42266e4598d63734db1005346f9180.jpeg";